import { VoidedObject } from "@/shared/models/voided-object.model";

export class CampusModel extends VoidedObject {
  _key?: string;
  name!: string;
  address!: string;
  phone!: string;
  countryCode!: string;
  state!: string;
}
